<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<style scoped lang="scss">
.effect-lists{
  //display: block!important;
  justify-content: space-between;
  flex-wrap:wrap;
  overflow: auto;
}
.cons{
  display: none;
}
.effect-lists li{
  margin-right: 30px;
  float: left;
  width: 18%;
  text-align: center;
  margin-bottom: 30px;
}
.effect-lists li:nth-last-of-type(1),.effect-lists li:nth-last-of-type(2),.effect-lists li:nth-last-of-type(3),.effect-lists li:nth-last-of-type(4),.effect-lists li:nth-last-of-type(5){
  margin-bottom: 0;
}
.effect-lists li:nth-child(5n){
  margin-right: 0;
}
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (max-width: 414px) and (min-width: 413px),
screen and (max-width: 640px) and (min-width: 600px),
screen and (min-width: 300px) and (max-width:400px)
{
  .effect-lists{
    justify-content: flex-start!important;
  }
}
</style>
<template>
  <div class="wrap wrap-tec">
    <div class="banner">
      <img src="@/assets/img/产品及服务/常规分子项目/banner2.jpg" class="img-fluid">
      <div class="info">
<!--        <div class="container">-->
<!--          <h1>PCR扩增</h1>-->
<!--          <h2 class="mt10">PCR amplification</h2>-->
<!--        </div>-->
      </div>
    </div>
    <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-top:  20px;">
      <bread></bread>
    </div>
    <section class="container">
      <p class="desc">承接DNA、鼠尾、血液、唾液等可直扩样品的PCR批量检测。</p>
      <div class="c-title">实验方案<small>Experimental Program</small></div>
      <el-row type="flex" align="bottom">
        <el-col :span="12">
          <img src="@/assets/images/pcr_1.jpg" class="img-fluid">
        </el-col>
        <el-col :span="12">
          <div class="required" style="height:280px;">
            <p>根据不同的样品及DNA序列情况，选取不同的扩增程序和PCR
              Mix，我公司研发了针对高保真、高级结构、超长片段的PCR
              Mix，同时可以在30分钟内完成一次PCR实验，拥有多台PCR
              仪，能够高效完成PCR扩增实验。</p>
          </div>
        </el-col>
      </el-row>
      <div class="c-title">服务流程<small>Service Process</small></div>
      <el-row type="flex" align="bottom">
        <el-col :span="12" style="z-index: 2">
          <div class="required left" style="height:280px;">
            <p class="mb20">1、提供DNA模板，组织（动物/植物组织、临床样本、种子样本、贴壁/悬浮细胞、全血/血清样品、石蜡包埋样品）；</p>
            <p class="mb20">2、进行序列分析并设计引物优化实验条件进行扩增检测。</p>
          </div>
        </el-col>
        <el-col :span="12">
          <img src="@/assets/images/pcr_2.jpg" class="img-fluid">
        </el-col>
      </el-row>
      <div class="c-title">结果交付<small>Delivery Of Results</small></div>
      <el-row type="flex" align="bottom">
        <el-col :span="12">
          <img src="@/assets/images/pcr_3.jpg" class="img-fluid">
        </el-col>
        <el-col :span="12">
          <div class="required" style="height:280px;">
            <p class="mb20">1、提供电子版样品信息表，琼脂糖电泳胶图，注明maker大小、
              扩增产物大小；</p>
            <p class="mb20">2、提供扩增后的PCR产物，存于96孔PCR板中；</p>
            <p class="mb20">3、PCR产物浓度30 ng/μL以上、30 ~ 50 μL，特殊样品除外。</p>
          </div>
        </el-col>
      </el-row>
      <div class="c-title">实验案例<small>Experimental case</small></div>
      <div class="tc"><img src="@/assets/images/pcr_4.png"></div>
      <div class="c-title">相关服务<small>Related services</small></div>
<!--      <ul class="services">-->
<!--        <li><img src="@/assets/images/snp_service_2.png">DNA提取 </li>-->
<!--        <li><img src="@/assets/images/dna_icon_2.png">载体构建 </li>-->
<!--        <li><img src="@/assets/images/dna_icon_3.png">SNP检测 </li>-->
<!--        <li><img src="@/assets/images/dna_icon_4.png">Sanger测序 </li>-->
<!--        <li><img src="@/assets/images/dna_icon_5.png">引物合成 </li>-->
<!--        <li><img src="@/assets/images/dna_icon_7.png">质粒大提 </li>-->
<!--        <li><img src="@/assets/images/dna_icon_6.png">提取+扩增+测序+数据分析 </li>-->
<!--      </ul>-->
      <ul class="effect-lists con">
        <li v-for="(item, index) in types" :key="index" class="pointer" :class="{active: currentType === index}" @mouseover="currentType = index" @mouseout="currentType = -1" @click="$router.push(item.ref)">
          <img :src="`/static/img/Project_${item.img}${currentType===index ? '' : ''}.png`">
          <p style="margin-top: 10px;">{{item.name}}</p>
        </li>
      </ul>
      <div class="cons">
        <ul class="effect-lists" style="margin-top: 20px;display: flex!important;">
          <li v-for="(item, index) in types" :key="index" class="pointer"   @click="$router.push(item.ref)">
            <img :src="`/static/img/Project_${item.img}${currentType===index ? '' : ''}.png`" style="width: 60px;">
            <p style="margin-top: 10px;font-size: 12px">{{item.name}}</p>
          </li>
        </ul>
      </div>

    </section>
    <qk-consult type="Virus"/>
  </div>
</template>
<script>
import bread from "@/components/bread"
export default {
  components: {
    bread,
  },
  data () {
    return {
      currentType:-1,
      types: [
        {name: 'DNA提取', img: '1', ref: '/tec/DNA_extraction'},
        {name: '荧光定量PCR', img: '7', ref: '/tec/qPCR'},
        {name: '菌种鉴定', img: '8', ref: '/tec/rDNA'},
      ],
    }
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/views/tec/PCR.vue